import { IAuthDriver } from 'src/app/services/auth/drivers/auth-driver.interface';
import { AngularFireAuth } from "@angular/fire/auth";
import { LoggedUser } from 'src/app/models/auth/logged-user.model';
import * as firebase from 'firebase/app';

export class FirebaseAuthDriver implements IAuthDriver {
  static settings: any = null;

  static async load(): Promise<any> {
    try {
      const response = await fetch("/assets/os/drivers/auth/firebase.json");
      const json = await response.json();
      FirebaseAuthDriver.settings = json;
    }
    catch (err) {
      //  TODO
    }
  }

  constructor(private authSv: AngularFireAuth) {
  }

  // constructor(
  //   private google: GooglePlus,
  //   private logger: LoggerService,
  //   private session: SessionDataService,
  //   private authSv: AngularFireAuth) {
  // }

  async initialize() {
    // await this.authSv.auth.setPersistence("local");

    // this.authSv.auth.onAuthStateChanged(async (m) => {
    //   const success = await this.restore(m);
    //   if (success) {
    //     this.onLogin.emit(this.session.loggedUser);
    //   }
    // });
  }

  async getCurrentUser() {
    return await this.authSv.currentUser;
  }

  async restore(user?: firebase.User) {
    if (!user) {
      user = await this.getCurrentUser();
    }

    if (user && !user.isAnonymous) {
      return this.fillUser(new LoggedUser(), user);
    }

    return null;
  }

  async logout() {
    await this.authSv.signOut();
  }

  getSupportedProviders(): string[] {
    return ["google"];
  }

  signInWithProvider(provider: string): Promise<LoggedUser> {
    if (provider === "google") {
      return this.loginWithGoogle();
    }

    throw new Error(`Unknown provider: ${provider}`);
  }

  async signInWithEmailAndPassword(email, password) {
    const credentials = await this.authSv.signInWithEmailAndPassword(email, password);
    return this.fillUser(new LoggedUser(), credentials.user);
  }

  async sendPasswordResetEmail(email): Promise<any> {
    await this.authSv.sendPasswordResetEmail(email);
  }

  async changePassword(currentEmail: string, password: string, newPassword: string): Promise<boolean> {
    const user = await this.authSv.signInWithEmailAndPassword(currentEmail, password);
    if (user) {
      await user.user.updatePassword(newPassword);
      return true;
    }

    return false;
  }

  async changeEmail(currentEmail: string, password: string, newEmail: string): Promise<boolean> {
    const user = await this.authSv.signInWithEmailAndPassword(currentEmail, password);
    if (user) {
      await user.user.updateEmail(newEmail);
      return true;
    }

    return false;
  }

  async signUp(name, email, password): Promise<LoggedUser> {
    const user = await this.authSv.createUserWithEmailAndPassword(email, password);

    await user.user.updateProfile({
      displayName: name
    });

    const credentials = await this.authSv.signInWithEmailAndPassword(email, password);
    return this.fillUser(new LoggedUser(), credentials.user);
  }

  private fillUser(user: LoggedUser, data: any): LoggedUser {
    user.info = data;
    user.name = data.displayName;
    user.email = data.email;
    return user;
  }

  private async loginWithGoogle(): Promise<LoggedUser> {
    const GoogleAuthProvider = firebase.auth.GoogleAuthProvider;
    const provider = new GoogleAuthProvider();

    provider.addScope("profile");
    provider.addScope("email");

    const credentials = await this.authSv.signInWithPopup(provider);

    if (!credentials) {
      return null;
    }

    return this.fillUser(new LoggedUser(), credentials.user);
  }
}
